module.exports = __webpack_public_path__ + "static/media/visa.faf2dafe.jpg";